<template>
  <div class="container form-renderer-form">
    <div class='form-message' :class="{error: formMessage && formMessage.type === 'error'}" v-if="formMessage && formMessage.message">
      <p>{{ formMessage.message }}</p>
    </div>
    <span
      class="field-category-group"
      v-for="fieldGroup in getFieldGroupKeys()"
      :key="fieldGroup"
    >
      <h4 v-if="fieldGroup !== '__noCategory'" :style="{'color': groupHeaderColor }">{{ fieldGroup }}</h4>
      <form-field
        v-for="(field, index) in fields[fieldGroup]"
        :key="index"
        :containerStyles="{
          width: `${field.classList && field.classList.includes('long')
            ? '96%'
            : '48%'}`
        }"
        :addClass="field.classList || ''"
        :label="field.label"
        :values="{ ...formData }"
        :name="field.name"
        :onUpdate="updateField"
        :errors="{...errors}"
        :type="field.type || 'text'"
        :disabled="field.disabled || formDisabled || false"
      />
    </span>
    <div class="long right p-20">
      <button class="green p-10" @click="submitForm" :disabled="formDisabled">Submit</button>
    </div>
  </div>
</template>

<script>
import FormField from "./FormField";
export default {
  name: "FormRenderer",
  data: () => ({
    formLoaded: false,
    formData: {},
    errors: {},
    fields: {}
  }),
  components: { FormField },
  props: ["fieldData", "onSubmit", "styler", "formDisabled", "formMessage", 'order'],
  mounted: function() {
    this.resetFields();
  },
  computed: {
      groupHeaderColor: function () {  return this.styler && this.styler.groupHeaderColor || '#000' }
  },
  methods: {
    getFieldGroupKeys() {
      let keys = this.order ? [...this.order] : []
      return [...keys, ...Object.keys(this.fields).filter(key => !keys.includes(key))]
    },
    makeFieldItem(name, label, category, classList, defaultVal, fieldType, disabled) {
      let compField = {};
      if (name) compField.name = name;
      if (label) compField.label = label;
      if (category) compField.category = category;
      if (classList) compField.classList = classList;
      if (defaultVal) compField.default = defaultVal;
      if (fieldType) compField.type = fieldType;
      if (disabled) compField.disabled = disabled
      return compField;
    },
    resetFields() {
      this.errors = {};
      let defaultFormData = {};
      this.fields = this.fieldData.reduce((p, c) => {
        const cat = c.category || "__noCategory";
        if (c.default) {
          defaultFormData[c.name] = c.default;
        }
        if (p[cat]) {
          p[cat].push(c);
        } else {
          p[cat] = [c];
        }
        return p;
      }, {});
      this.formData = { ...defaultFormData };
    },
    submitForm() {
      let errors = {};
      this.errors = errors;
      if (Object.keys(errors).length < 1) {
        this.onSubmit && this.onSubmit(this.formData);
      }
    },
    updateField(e) {
      this.formData[e.target.name] = e.target.value;
    }
  }
};
</script>

<style lang="scss">
.form-renderer-form {
  overflow: auto;
  padding-bottom: 16px;
  border-radius: 5px;
  width: 96%;
  margin: 10px auto 50px auto;
  background-color: #fff;
  h4 {
    width: 96%;
    font-size: 1.3rem;
    margin: 31px 0 5px 0;
  }

  & > span {
    width: 100%;
    display: flex;
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: center;
    h4 {
      width: 96%;
    }
  }
  & .field-category-group div {
    label {
      display: block;
      width: 100%;
      font-weight: bold;
      margin-bottom: 13px;
      margin-top: 20px;
      width: calc(96% - 20px);
      color: rgb(161, 161, 161);
    }
    .check-box {
      margin-top: 15px;
      width: 100%;
      display: flex;
      align-content: center;
      label {
        cursor: pointer;
        width: auto;
      }
      input[type="checkbox"] {
        cursor: pointer;
        display: block;
        margin: 22px 10px 0 0;
      }
    }
    input[type="text"],
    input[type="number"],
    input[type="date"],
    select,
    textarea {
      box-shadow: 0 0 0 1px rgb(117, 197, 228);
      padding: 13px 10px;
      border-radius: 4px;
      background-color: rgb(240, 251, 255);
      width: calc(96% - 20px);
      transition: background-color 0.5s, box-shadow 0.5s;
      &:focus {
        background-color: rgb(217, 243, 252);
        box-shadow: 0 0 0 1px rgb(41, 155, 201);
      }

      &:disabled {
        background-color: rgb(235, 235, 235);
        box-shadow: 0 0 0 1px rgb(192, 192, 192);
        color: gray;
      }
    }
    input[type="date"] {
      padding: 10px 10px;
    }
    select {
      margin: 0;
      width: calc(100% - 20px);
      padding: 12px 0 11px 10px;
    }
    textarea {
      height: 125px;
      line-height: 1.75rem;
    }
    &.long {
      input[type="text"],
      textarea {
        border-radius: 4px;
        width: calc(98% - 20px);
      }
    }
  }
  @media screen and (max-width: 460px) {
    & .field-category-group div {
      width: 96%;
    }
  }
  .hasError {
    & input[type="text"],
    & input[type="number"],
    & input[type="date"],
    & select,
    & textarea {
      box-shadow: 0 0 0 1px rgb(228, 117, 117);
      background-color: rgb(255, 240, 247);
    }
    label {
      color: red;
    }
  }
  .field-error {
    font-style: italic;
    padding: 2px 8px;
    color: red;
    margin-top: 8px;
    border-radius: 5px;
    margin-left: 5px;
    color: #fff;
    background-color: red;
  }
  .form-message {
    width: 98%;
    margin: 0 auto;
    background-color: lightgreen;
    margin-bottom: 0;
    padding: 5px 0;
    margin-top: 8px;
    border-radius: 5px;
    box-shadow: 0 0 0 1px rgb(15, 221, 15);
    p {
      margin: 0;
      color: darkgreen;
      padding: 0;
      text-align: center;
      font-weight: bold;
    }
    &.error {
      background-color: rgb(243, 188, 188);
      box-shadow: 0 0 0 1px rgb(255, 107, 81);
      p {
        color: darkred;
      }
    }
  }
}
</style>
